import React from 'react';
import { Navigate } from 'react-router-dom';

const PublicRoute = ({ element: Component }) => {
  const token = localStorage.getItem('token');

  // If token exists, redirect to V2 Events (event-scoped users get
  // bounced to their own page by the catch-all route)
  if (token) {
    return <Navigate to="/v2/events" replace />;
  }

  // If not authenticated, allow access to public route (like login)
  return Component;
};

export default PublicRoute;